'use client';
import { ListContainer } from '@/hooks/use-board';
import { ArticleType } from '@/services/types/article.type';
import ContactList from './components/contact-list';

// 공지사항
export default function Client() {
  return (
    <ListContainer
      type={ArticleType.NOTICE}
      limit={10}
      render={({ items, page, totalPages, onPageChange }) => (
        <ContactList
          items={items}
          page={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    />
  );
}
